import { render, staticRenderFns } from "./virtual-keyboard.vue?vue&type=template&id=0fbe8342&scoped=true"
import script from "./virtual-keyboard.vue?vue&type=script&lang=js"
export * from "./virtual-keyboard.vue?vue&type=script&lang=js"
import style0 from "./virtual-keyboard.vue?vue&type=style&index=0&id=0fbe8342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbe8342",
  null
  
)

export default component.exports